import React from "react";
import { connect } from "react-redux";
import DataGrid, {
  Scrolling,
  Sorting,
  HeaderFilter,
  Column,
  Selection,
} from "devextreme-react/ui/data-grid";

import NumberField from "../../../Shared/fields/NumberField";
import DateField from "../../../Shared/fields/DateField";
import { getTareasAprobada, aprobarTareas, restoTareas, dataLayerTag } from "../functions";
import { editarSubMedidaTareaSeguimiento, onAlertaPlanMovilidad, handlerMedidasLoading } from "../actions";

// archivos
import A1_1 from "../../Descargable/Acciones/1.1.zip";
import A1_2 from "../../Descargable/Acciones/1.2.zip";
import A1_3 from "../../Descargable/Acciones/1.3.zip";
import A1_4 from "../../Descargable/Acciones/1.4.zip";
import A2_1 from "../../Descargable/Acciones/2.1.zip";
import A2_2 from "../../Descargable/Acciones/2.2.zip";
import A2_3 from "../../Descargable/Acciones/2.3.zip";
import A3_1 from "../../Descargable/Acciones/3.1.zip";
import A3_2 from "../../Descargable/Acciones/3.2.zip";
import A3_3 from "../../Descargable/Acciones/3.3.zip";
import A4_1 from "../../Descargable/Acciones/4.1.zip";
import A4_2 from "../../Descargable/Acciones/4.2.zip";
import A4_3 from "../../Descargable/Acciones/4.3.zip";
import A4_4 from "../../Descargable/Acciones/4.4.zip";
import A5_1 from "../../Descargable/Acciones/5.1.zip";
import A5_2 from "../../Descargable/Acciones/5.2.zip";
import A5_3 from "../../Descargable/Acciones/5.3.zip";
import A5_4 from "../../Descargable/Acciones/5.4.zip";
import A6_1 from "../../Descargable/Acciones/6.1.zip";
import A6_2 from "../../Descargable/Acciones/6.2.zip";
import A6_3 from "../../Descargable/Acciones/6.3.zip";
import A6_4 from "../../Descargable/Acciones/6.4.zip";
import A6_5 from "../../Descargable/Acciones/6.5.zip";
import A6_6 from "../../Descargable/Acciones/6.6.zip";
import A6_7 from "../../Descargable/Acciones/6.7.zip";
import A6_8 from "../../Descargable/Acciones/6.8.zip";
import A6_9 from "../../Descargable/Acciones/6.9.zip";
import A6_10 from "../../Descargable/Acciones/6.10.zip";
import A7_1 from "../../Descargable/Acciones/7.1.zip";
import A8_1 from "../../Descargable/Acciones/8.1.zip";
import A8_2 from "../../Descargable/Acciones/8.2.zip";

const ColoredLine = ({ color }) => (
  <hr
    style={{
      color,
      backgroundColor: color,
      height: 1,
    }}
  />
);

class SubMedidaItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tareas: (this.props.data.tblPlanSubMedidaTarea ? this.props.data.tblPlanSubMedidaTarea : null),
      totalEntrega: (this.props.data.totalEntrega ? this.props.data.totalEntrega : 0),
      totalObjetivo: (this.props.data.totalObjetivo ? this.props.data.totalObjetivo : 0),
      estadoSubMedida: (this.props.data.estadoSubMedida ? this.props.data.estadoSubMedida : 2),
      tareasAprobadas: (this.props.data.tblPlanSubMedidaTarea ? getTareasAprobada(this.props.data.tblPlanSubMedidaTarea) : null),
      fechaInicio: (this.props.data.fechaInicio ? this.props.data.fechaInicio : null),
      fechaLimite: (this.props.data.fechaLimite ? this.props.data.fechaLimite : null),
    };
  }

  handleChange = (e) => {
    switch (e.element.id) {
      case "totalEntrega":
        this.setState({ totalEntrega: e.value });
        break;
      case "totalObjetivo":
        this.setState({ totalObjetivo: e.value });
        break;
      case "fechaInicioSubMedida":
        this.setState({ fechaInicio: e.value });
        break;
      case "fechaLimiteSubMedida":
        this.setState({ fechaLimite: e.value });
        break;
      default:
        console.log(`ERROR! ${e}`);
        break;
    }
  }

  handleWorkerSelect = (e) => {
    this.setState({ tareasAprobadas: e.selectedRowKeys });
  }

  guardarSubMedida = () => {
    this.props.dispatch(handlerMedidasLoading(true));
    const tareasAprobadas = aprobarTareas(this.state.tareasAprobadas);
    const tareasDesaprobadas = restoTareas(this.props.data.tblPlanSubMedidaTarea, this.state.tareasAprobadas, );
    this.props.dispatch(editarSubMedidaTareaSeguimiento(this.props.idplanMovilidad, this.props.data.idplanSubMedida, 0, this.state.totalEntrega, this.state.totalObjetivo, tareasAprobadas.concat(tareasDesaprobadas), this.state.fechaInicio, this.state.fechaLimite));
  }

  finalizarSubMedida = () => {
    this.props.dispatch(handlerMedidasLoading(true));
    if (this.state.tareas.length !== this.state.tareasAprobadas.length) {
      this.props.dispatch(onAlertaPlanMovilidad("error", "Debe completar todas las tareas para finalizar la acción"));
      this.props.dispatch(handlerMedidasLoading(false));
    } else {
      const tareasAprobadas = aprobarTareas(this.state.tareasAprobadas);
      this.props.dispatch(editarSubMedidaTareaSeguimiento(this.props.idplanMovilidad, this.props.data.idplanSubMedida, 1, this.state.totalEntrega, this.state.totalObjetivo, tareasAprobadas, this.state.fechaInicio, this.state.fechaLimite));
      // gtd -> finaliza una acción
      const nombreAcciones = [];
      for(let i=0; i<this.state.tareas.length; i++){
        nombreAcciones.push(this.state.tareas[i].descripcion);
      }
      dataLayerTag({
        'event': 'etapa_4_finalizo_accion',
        'etapa': '4',
        'acciones_checkeadas': nombreAcciones,
      });
      this.contarTareasTotalesPorMedidas(this.props.medidas, tareasAprobadas);
    }
  }

  contarTareasTotalesPorMedidas = (m, TA) => {
    var accion = null;
    let TT = 0;
    let TF = 0;
    for (let i=0; i<m.tblPlanSubMedida.length; i++){
      accion = m.tblPlanSubMedida[i];
      // sumo todas mis tareas de la medida
      TT = TT + accion.tblPlanSubMedidaTarea.length;
      if (accion.estadoSubMedida === 1){
        // sumo las tareas de las medidas que están finalizadas
        TF = TF + accion.totalTareasFinalizadas;
      }
    }
    // sumo las que deberían aprobar con el botón
    TF = TF + TA.length;
    if (TT === TF){
      // Si tengo todas las tareas finalizadas, asumo que se finaliza la medidav
      const nombreAcciones = [];
      for(let i=0; i<this.state.tareas.length; i++){
        nombreAcciones.push(this.state.tareas[i].descripcion);
      }
      dataLayerTag({
        'event': 'etapa_4_finalizo_medida',
        'etapa': '4',
        'acciones_checkeadas': nombreAcciones,
      });
    }
  }

  descargaKitAccion = (codigo) => {
    const archivos = [
      {file: A1_1, code:'1.1'},
      {file: A1_2, code:'1.2'},
      {file: A1_3, code:'1.3'},
      {file: A1_4, code:'1.4'},
      {file: A2_1, code:'2.1'},
      {file: A2_2, code:'2.2'},
      {file: A2_3, code:'2.3'},
      {file: A3_1, code:'3.1'},
      {file: A3_2, code:'3.2'},
      {file: A3_3, code:'3.3'},
      {file: A4_1, code:'4.1'},
      {file: A4_2, code:'4.2'},
      {file: A4_3, code:'4.3'},
      {file: A4_4, code:'4.4'},
      {file: A5_1, code:'5.1'},
      {file: A5_2, code:'5.2'},
      {file: A5_3, code:'5.3'},
      {file: A5_4, code:'5.4'},
      {file: A6_1, code:'6.1'},
      {file: A6_2, code:'6.2'},
      {file: A6_3, code:'6.3'},
      {file: A6_4, code:'6.4'},
      {file: A6_5, code:'6.5'},
      {file: A6_6, code:'6.6'},
      {file: A6_7, code:'6.7'},
      {file: A6_8, code:'6.8'},
      {file: A6_9, code:'6.9'},
      {file: A6_10, code:'6.10'},
      {file: A7_1, code:'7.1'},
      {file: A8_1, code:'8.1'},
      {file: A8_2, code:'8.2'},
    ];

    for (let i=0; i<archivos.length; i++){
      if (archivos[i].code === codigo){
        window.open(archivos[i].file,"_blank");
        break
      }
    }
  }

  render() {
    return (
      <div>
        <div className="col-xs-12 col-md-12">
          <ColoredLine color="#F2F2F2" />
        </div>
        {
          (this.props.data.estadoSubMedida === 1 || !this.props.esEncargado )?

            <DataGrid
              showBorders={false}
              dataSource={this.state.tareas}
              className="roles-empresa"
              showColumnLines={false}
              showRowLines={false}
              rowAlternationEnabled
              selectedRowKeys={this.state.tareasAprobadas}
              noDataText="No hay tareas"
              ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
              loadPanel={{
                enabled: true,
              }}
              onSelectionChanged={this.handleWorkerSelect}
            >
              <HeaderFilter visible={false} />
              <Sorting mode="multiple" />
              <Scrolling columnRenderingMode="virtual" />

              <Column
                caption="¿Completada?"
                alignment="center"
                width="150"
                cellComponent={(row) => (<div>{row.data.completada ? <i className="achs-icon" style={{ color: "green", fontSize: 55, marginTop: -9 }}> c </i> : <i className="achs-icon"style={{ color: "red", fontSize: 55, marginTop: -8 }}> d </i>}</div>)}
              />

              <Column
                caption="Nombre tarea"
                dataField="descripcion"
              />
            </DataGrid>
            :
            <DataGrid
              showBorders={false}
              dataSource={this.state.tareas}
              className="roles-empresa"
              showColumnLines={false}
              showRowLines={false}
              rowAlternationEnabled
              selectedRowKeys={this.state.tareasAprobadas}
              noDataText="No hay tareas"
              ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
              loadPanel={{
                enabled: true,
              }}
              onSelectionChanged={this.handleWorkerSelect}
            >
              <HeaderFilter visible={false} />
              <Sorting mode="multiple" />
              <Scrolling columnRenderingMode="virtual" />

              <Selection
                showCheckBoxesMode="always"
                mode="multiple"
                allowSelectAll={false}
              />

              <Column
                caption="¿Completada?"
                alignment="center"
                width="150"
                cellComponent={(row) => (<div>{row.data.completada ? <i className="achs-icon" style={{ color: "green", fontSize: 55, marginTop: -9 }}> c </i> : <i className="achs-icon"style={{ color: "red", fontSize: 55, marginTop: -8 }}> d </i>}</div>)}
              />

              <Column
                caption="Nombre tarea"
                dataField="descripcion"
              />
            </DataGrid>

        }

        <div className="zero col-xs-12 col-md-12">
          <ColoredLine color="#F2F2F2" />
        </div>
        <section id="content-etapa">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 text-left">
                <div className="col-md-12 pt-10">
                  <NumberField
                    inputAttr={{ maxLength: 4 }}
                    max={1000}
                    min={0}
                    label={this.props.data.tipoEntrega}
                    id="totalEntrega"
                    showSpinButtons
                    onChange={this.handleChange}
                    value={this.state.totalEntrega}
                    disabled={this.props.data.estadoSubMedida === 1 || !this.props.esEncargado}
                  />
                </div>
                {
                  (this.props.data.tipoObjetivo) ?
                    <div className="col-md-12 pt-10">
                      <NumberField
                        inputAttr={{ maxLength: 4 }}
                        max={1000}
                        min={0}
                        label={this.props.data.tipoObjetivo}
                        id="totalObjetivo"
                        showSpinButtons
                        onChange={this.handleChange}
                        value={this.state.totalObjetivo}
                        disabled={this.props.data.estadoSubMedida === 1 || !this.props.esEncargado}
                      />
                    </div>
                    :
                    <div className="col-md-12"></div>
                }
                <div className="col-md-12 pt-10">
                  <DateField
                    styleRoot={{ marginTop: 0 }}
                    label="Fecha inicio"
                    id="fechaInicioSubMedida"
                    onChange={this.handleChange}
                    type="date"
                    min={new Date().setFullYear(1000)}
                    max={new Date().setFullYear(3000)}
                    value={this.state.fechaInicio}
                    disabled={this.props.data.estadoSubMedida === 1 || !this.props.esEncargado}
                  />
                </div>
                <div className="col-md-12 pt-10">
                  <DateField
                    styleRoot={{ marginTop: 0 }}
                    label="Fecha límite"
                    id="fechaLimiteSubMedida"
                    onChange={this.handleChange}
                    type="date"
                    min={new Date().setFullYear(1000)}
                    max={new Date().setFullYear(3000)}
                    value={this.state.fechaLimite}
                    disabled={this.props.data.estadoSubMedida === 1 || !this.props.esEncargado}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="btn-box row PM-plan-botones-encuesta" style={{ marginTop: 5 }}>
            <div className="col-sm-6 text-left PM-button">
              <button
                className="btn PM-solo-borde PM-dx-button-plan-40"
                style={{ marginRight: 15 }}
                onClick={() => { this.descargaKitAccion(this.props.data.codigo); }}
                > Descargar kit</button>
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-40"
                onClick={this.guardarSubMedida}
                disabled={(this.props.data.estadoSubMedida === 1 || !this.props.esEncargado)}
              >Guardar</button>
            </div>
            <div className="col-sm-6 text-right">
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-40"
                onClick={this.finalizarSubMedida}
                disabled={(this.props.data.estadoSubMedida === 1 || !this.props.esEncargado)}
              >Finalizar acción</button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  isMedidasLoading: state.planMovilidad.isMedidasLoading,
  esEncargado: state.planMovilidad.esEncargado,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SubMedidaItem);
